import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0599e3dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "buy-attention" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "buy-attention__title" }, "لطفا توجه کنید:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "buy-attention__paragraph" }, " - توجه داشته باشید کارمزد انتقال در شبکه، 3 تتر میباشد و وبسایت والت در آن ذینفع نیست. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "buy-attention__paragraph" }, " - در صورتی که آدرس کیف پول خود را اشتباه وارد کنید، تراکنش قابل برگشت نخواهد بود و وبسایت والت هیچگونه مسئولیتی در مورد از بین رفتن دارایی شما قبول نخواهد داشت. ", -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}